export default __webpack_public_path__ + "static/media/282.ae924445.jpg";